import defaultValues from '../lib/defaultValues.js'

const state = {
  address: defaultValues.serviceProviderCompanyAddress,
  category: defaultValues.serviceProviderCompanyCategory,
  callNumber: defaultValues.serviceProviderCompanyCallPhoneNumber,
  couponText: defaultValues.serviceProviderCompanyCouponText,
  details: defaultValues.serviceProviderCompanyDetails,
  email: defaultValues.serviceProviderCompanyEmail,
  companyId: defaultValues.serviceProviderCompanyId,
  latitude: defaultValues.serviceProviderCompanyLatitude,
  logo: defaultValues.serviceProviderCompanyLogo,
  longitude: defaultValues.serviceProviderCompanyLongitude,
  companyName: defaultValues.serviceProviderCompanyName,
  paymentHistory: JSON.parse(JSON.stringify(defaultValues.serviceProviderCompanyPaymentHistory)),
  preferredCommunication: JSON.parse(JSON.stringify(defaultValues.serviceProviderCompanyPreferredCommunication)),
  ownerId: defaultValues.serviceProviderCompanyOwnerId,
  premium: defaultValues.serviceProviderCompanyPremium,
  referralText: defaultValues.serviceProviderCompanyReferralText,
  subscriptionId: defaultValues.serviceProviderCompanySubscriptionId,
  subscriptionPrice: defaultValues.serviceProviderCompanySubscriptionPrice,
  subscriptionDiscountAmount: defaultValues.serviceProviderCompanySubscriptionDiscountAmount,
  subscriptionDiscountExpirationDate: defaultValues.serviceProviderCompanySubscriptionDiscountExpirationDate,
  subscriptionStartDate: defaultValues.serviceProviderCompanySubscriptionStartDate,
  subscriptionEndDate: defaultValues.serviceProviderCompanySubscriptionEndDate,
  subscriptionNextBillingDate: defaultValues.serviceProviderCompanySubscriptionNextBillingDate,
  subscriptionCreditCardType: defaultValues.serviceProviderCompanySubscriptionCreditCardType,
  subscriptionCreditCardLastFour: defaultValues.serviceProviderCompanySubscriptionCreditCardLastFour,
  subscriptionCustomFlag: defaultValues.serviceProviderCompanySubscriptionCustomFlag,
  subscriptionRenewal: defaultValues.serviceProviderCompanySubscriptionRenewal,
  textNumber: defaultValues.serviceProviderCompanyTextPhoneNumber
}

const getters = {
  getAddress: (state) => {
    return state.address
  },
  getCallNumber: (state) => {
    if (!state.callNumber) return state.callNumber
    let x = state.callNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  },
  getCategory: (state) => {
    return state.category
  },
  getCouponText: (state) => {
    return state.couponText
  },
  getDetails: (state) => {
    return state.details
  },
  getEmail: (state) => {
    return state.email
  },
  getCompanyId: (state) => {
    return state.companyId
  },
  getLatitude: (state) => {
    return state.latitude
  },
  getLogo: (state) => {
    if (state.logo && window.CONFIG && state.companyId && state.logo.includes(state.companyId)) {
      let baseURL = 'https://s3.' + window.CONFIG.Region + '.amazonaws.com/' + window.CONFIG.PhotoBucketName + '/'
      return baseURL + state.logo
    }
    return state.logo
  },
  getLongitude: (state) => {
    return state.longitude
  },
  getCompanyName: (state) => {
    return state.companyName
  },
  getOwnerId: (state) => {
    return state.ownerId
  },
  getPaymentHistory: (state) => {
    return state.paymentHistory
  },
  getPreferredCommunication: (state) => {
    return state.preferredCommunication
  },
  getPremium: (state) => {
    return state.premium
  },
  getReferralText: (state) => {
    return state.referralText
  },
  getSubscriptionId: (state) => {
    return state.subscriptionId
  },
  getSubscriptionPrice: (state) => {
    return state.subscriptionPrice
  },
  getSubscriptionDiscountAmount: (state) => {
    return state.subscriptionDiscountAmount
  },
  getSubscriptionDiscountExpirationDate: (state) => {
    return state.subscriptionDiscountExpirationDate
  },
  getSubscriptionStartDate: (state) => {
    return state.subscriptionStartDate
  },
  getSubscriptionEndDate: (state) => {
    return state.subscriptionEndDate
  },
  getSubscriptionNextBillingDate: (state) => {
    return state.subscriptionNextBillingDate
  },
  getSubscriptionRenewal: (state) => {
    return state.subscriptionRenewal
  },
  getSubscriptionCreditCardType: (state) => {
    return state.subscriptionCreditCardType
  },
  getSubscriptionCreditCardLastFour: (state) => {
    return state.subscriptionCreditCardLastFour
  },
  getSubscriptionCustomFlag: (state) => {
    return state.subscriptionCustomFlag
  },
  getTextNumber: (state) => {
    if (!state.textNumber) return state.textNumber
    let x = state.textNumber.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/)
    return !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '')
  }
}

const mutations = {
  updateAddress: (state, address) => {
    state.address = address
  },
  updateCallNumber: (state, phoneNumber) => {
    if (phoneNumber) phoneNumber = phoneNumber.match(/(\d+)/g).join('')
    state.callNumber = phoneNumber
  },
  updateCategory: (state, category) => {
    state.category = category
  },
  updateCouponText: (state, couponText) => {
    state.couponText = couponText
  },
  updateDetails: (state, details) => {
    state.details = details
  },
  updateEmail: (state, email) => {
    state.email = email
  },
  updateCompanyId: (state, id) => {
    state.companyId = id
  },
  updateLatitude: (state, latitude) => {
    state.latitude = latitude
  },
  updateLogo: (state, logo) => {
    state.logo = logo
  },
  updateLongitude: (state, longitude) => {
    state.longitude = longitude
  },
  updateCompanyName: (state, companyName) => {
    state.companyName = companyName
  },
  updateOwnerId: (state, ownerId) => {
    state.ownerId = ownerId
  },
  updatePaymentHistory: (state, paymentHistory) => {
    state.paymentHistory = paymentHistory
  },
  updatePreferredCommunication: (state, preferredCommunication) => {
    state.preferredCommunication = preferredCommunication
  },
  addPreferredCommunication: (state, communication) => {
    if (!state.preferredCommunication.includes(communication)) {
      state.preferredCommunication.push(communication)
    }
  },
  removePreferredCommunication: (state, communication) => {
    var index = state.preferredCommunication.indexOf(communication)
    if (index > -1) {
      state.preferredCommunication.splice(index, 1)
    }
  },
  updateReferralText: (state, referralText) => {
    state.referralText = referralText
  },
  updatePremium: (state, premium) => {
    state.premium = premium
  },
  updateSubscriptionId: (state, subscriptionId) => {
    state.subscriptionId = subscriptionId
  },
  updateSubscriptionPrice: (state, subscriptionPrice) => {
    state.subscriptionPrice = subscriptionPrice
  },
  updateSubscriptionDiscountAmount: (state, subscriptionDiscountAmount) => {
    state.subscriptionDiscountAmount = subscriptionDiscountAmount
  },
  updateSubscriptionDiscountExpirationDate: (state, subscriptionDiscountExpirationDate) => {
    state.subscriptionDiscountExpirationDate = subscriptionDiscountExpirationDate
  },
  updateSubscriptionStartDate: (state, subscriptionStartDate) => {
    state.subscriptionStartDate = subscriptionStartDate
  },
  updateSubscriptionEndDate: (state, subscriptionEndDate) => {
    state.subscriptionEndDate = subscriptionEndDate
  },
  updateSubscriptionNextBillingDate: (state, subscriptionNextBillingDate) => {
    state.subscriptionNextBillingDate = subscriptionNextBillingDate
  },
  updateSubscriptionRenewal: (state, subscriptionRenewal) => {
    state.subscriptionRenewal = subscriptionRenewal
  },
  updateSubscriptionCreditCardType: (state, subscriptionCreditCardType) => {
    state.subscriptionCreditCardType = subscriptionCreditCardType
  },
  updateSubscriptionCreditCardLastFour: (state, subscriptionCreditCardLastFour) => {
    state.subscriptionCreditCardLastFour = subscriptionCreditCardLastFour
  },
  updateSubscriptionCustomFlag: (state, subscriptionCustomFlag) => {
    state.subscriptionCustomFlag = subscriptionCustomFlag
  },
  updateTextNumber: (state, phoneNumber) => {
    if (phoneNumber) phoneNumber = phoneNumber.match(/(\d+)/g).join('')
    state.textNumber = phoneNumber
  }
}

const actions = {
  async getBtToken ({ commit, state, rootGetters }) {
    var client = rootGetters.getServiceProviderApigClientFactory
    var params = {}
    var pathTemplate = '/serviceproviders/bt-token'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async getPaymentHistory ({ commit, state, rootGetters }) {
    var client = rootGetters.getServiceProviderApigClientFactory
    var params = {}
    var pathTemplate = '/serviceproviders/paymenthistory'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    try {
      if ('data' in result) commit('updatePaymentHistory', result.data)
    } catch (error) {
      console.log(error)
    }
  },
  async premiumSignup ({ commit, state, rootGetters }, parameters) {
    var client = rootGetters.getServiceProviderApigClientFactory
    var params = {}
    var pathTemplate = '/serviceproviderpremium/signup'
    var method = 'POST'
    var additionalParams = {}
    var body = {
      'payment_method_nonce': parameters.payload.nonce,
      'promotion_code': parameters.code
    }
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async switchRenewalStatus ({ commit, state, rootGetters }) {
    var client = rootGetters.getServiceProviderApigClientFactory
    var params = {}
    var pathTemplate = '/serviceproviderpremium/switch'
    var method = 'PATCH'
    var additionalParams = {}
    var body = {}
    var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
    return result.data.client_token
  },
  async getCurrentServiceProviderData ({ commit, state, rootGetters }, companyId) {
    var client = rootGetters.getServiceProviderApigClientFactory
    var params = {'unique_id': companyId}
    var pathTemplate = '/serviceproviders/{unique_id}'
    var method = 'GET'
    var additionalParams = {}
    var body = {}
    try {
      var result = await client.invokeApi(params, pathTemplate, method, additionalParams, body)
      if ('address' in result.data) commit('updateAddress', result.data.address)
      if ('call_number' in result.data) commit('updateCallNumber', result.data.call_number)
      if ('coupon_text' in result.data) commit('updateCouponText', result.data.coupon_text)
      if ('unique_id' in result.data) commit('updateCompanyId', result.data.unique_id)
      if ('owner_ids' in result.data) commit('updateOwnerId', result.data.owner_ids[0])
      if ('business_name' in result.data) commit('updateCompanyName', result.data.business_name)
      if ('details' in result.data) commit('updateDetails', result.data.details)
      if ('images' in result.data) commit('updateLogo', result.data.images[0])
      if ('email' in result.data) commit('updateEmail', result.data.email)
      if ('preferred_communication' in result.data) commit('updatePreferredCommunication', result.data.preferred_communication)
      if ('premium' in result.data) commit('updatePremium', result.data.premium)
      if ('referral_text' in result.data) commit('updateReferralText', result.data.referral_text)
      if ('category' in result.data) commit('updateCategory', result.data.category)
      if ('latitude' in result.data) commit('updateLatitude', result.data.latitude)
      if ('longitude' in result.data) commit('updateLongitude', result.data.longitude)
      if ('subscription' in result.data) {
        commit('updateSubscriptionId', result.data.subscription.subscription_id)
        commit('updateSubscriptionPrice', result.data.subscription.price)
        commit('updateSubscriptionStartDate', result.data.subscription.billing_period_start_date)
        commit('updateSubscriptionEndDate', result.data.subscription.billing_period_end_date)
        commit('updateSubscriptionCreditCardType', result.data.subscription.credit_card_type)
        commit('updateSubscriptionCreditCardLastFour', result.data.subscription.credit_card_last_four)
        if (result.data.subscription.custom) commit('updateSubscriptionCustomFlag', result.data.subscription.custom)
        if (result.data.subscription.discount_amount) {
          commit('updateSubscriptionDiscountAmount', result.data.subscription.discount_amount)
          commit('updateSubscriptionDiscountExpirationDate', result.data.subscription.discount_expiration_date)
        }
        if (result.data.subscription.next_billing_date) {
          commit('updateSubscriptionNextBillingDate', result.data.subscription.next_billing_date)
          commit('updateSubscriptionRenewal', true)
        } else {
          commit('updateSubscriptionNextBillingDate', defaultValues.realtorSubscriptionNextBillingDate)
          commit('updateSubscriptionRenewal', defaultValues.realtorSubscriptionRenewal)
        }
      }
      if ('text_number' in result.data) commit('updateTextNumber', result.data.text_number)
    } catch (error) {
      console.log(error)
    }
  },
  async putServiceProviderData ({ commit, state, rootGetters }, { companyId, method = 'PUT' }) {
    console.log('Backend call')
    console.log(companyId)
    var client = rootGetters.getServiceProviderApigClientFactory
    var params = {'unique_id': companyId}
    var pathTemplate = '/serviceproviders/{unique_id}'
    var additionalParams = {}
    var body = {}
    if (state.address) body['address'] = state.address
    if (state.companyName) body['business_name'] = state.companyName
    if (state.callNumber) body['call_number'] = state.callNumber
    if (state.couponText) body['coupon_text'] = state.couponText
    if (state.details) body['details'] = state.details
    if (state.email) body['email'] = state.email
    if (state.logo) body['logo'] = state.logo
    if (state.ownerId) body['owner_ids'] = [state.ownerId]
    if (state.preferredCommunication.length) body['preferred_communication'] = state.preferredCommunication
    if (state.referralText) body['referral_text'] = state.referralText
    if (state.category) body['category'] = state.category
    if (state.latitude) body['latitude'] = state.latitude
    if (state.longitude) body['longitude'] = state.longitude
    // if (state.) body[''] = state.
    return client.invokeApi(params, pathTemplate, method, additionalParams, body)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/serviceProvider.js